import React from 'react';
import { useError } from './ErrorContext';
import Modal from '../components/Modal/Modal';
import alert from './alert';
import Button from '../components/Button/Button';
import { isConnectionError } from './isConnectionError';
export const generateCurlCommand = (error) => {
  if (!error?.config) return 'Unable to generate cURL command.';

  const { method, url, headers, data } = error.config;
  const formattedHeaders = Object.entries(headers || {})
    .map(([key, value]) => `-H "${key}: ${value}"`)
    .join(' ');

  const dataPart = data ? `-d '${JSON.stringify(data)}'` : '';

  return `curl -X ${method?.toUpperCase()} "${url}" ${formattedHeaders} ${dataPart}`;
};

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(
    () => alert.success('ÐÑÐ¸Ð±ÐºÐ° ÑÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°Ð½Ð° Ð² Ð±ÑÑÐµÑ Ð¾Ð±Ð¼ÐµÐ½Ð°'),
    (err) => alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸ Ð¾ÑÐ¸Ð±ÐºÐ¸: ', err)
  );
};

const GlobalErrorModal = () => {
  const { error, hideError } = useError();
  const [showDetails, setShowDetails] = React.useState(false);

  if (!error) return null;

  // ÐÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð±ÐµÑÐ¿Ð¾Ð»ÐµÐ·ÐµÐ½ ÑÑÐµÐº AxiosError Ð¸ Ð½Ð¾Ð¼ÐµÑÐ° Ð¼Ð¾Ð´ÑÐ»ÐµÐ¹ webpack: Ð¾Ð½ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ
  // Ð¿Ð¾ Ð½Ð¸Ð¼ Ð½Ð¸ÑÐµÐ³Ð¾ ÑÐ´ÐµÐ»Ð°ÑÑ. ÐÐ¾Ð²Ð¾ÑÐ¸Ð¼, ÑÑÐ¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð´Ð¸Ñ Ð¸ ÑÑÐ¾ Ð´ÐµÐ»Ð°ÑÑ, Ð° ÑÐµÑÐ½Ð¸ÑÐµÑÐºÐ¸Ðµ
  // Ð¿Ð¾Ð´ÑÐ¾Ð±Ð½Ð¾ÑÑÐ¸ Ð¿ÑÑÑÐµÐ¼ â ÑÐ°Ð·ÑÐ°Ð±Ð¾ÑÑÐ¸ÐºÑ Ð¾Ð½Ð¸ Ð¾ÑÑÐ°ÑÑÑÑ Ð² Ð¾Ð´Ð¸Ð½ ÐºÐ»Ð¸Ðº.
  const connectionError = isConnectionError(error);

  const handleCopyCurl = () => {
    const curlCommand = generateCurlCommand(error);
    copyToClipboard(curlCommand);
  };

  const handleCopyError = () => {
    const errorInfo = JSON.stringify(error, null, 2);
    copyToClipboard(errorInfo);
  };

  return (
    <Modal
      isOpen={!!error}
      title={connectionError ? 'Ð¡ÐµÑÐ²ÐµÑ ÑÐµÐ¹ÑÐ°Ñ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½' : 'ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ°'}
      onRequestClose={hideError}
      contentStyle={{
        maxHeight: 400,
        maxWidth: 600,
      }}
    >
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}>
        <div style={{
          maxHeight: 200,
          overflow: 'auto',
          padding: 20,
          marginBottom: 20,
        }}>
          {connectionError ? (
            <>
              <p>
                ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ²ÑÐ·Ð°ÑÑÑÑ Ñ ÑÐµÑÐ²ÐµÑÐ¾Ð¼. ÐÐ±ÑÑÐ½Ð¾ ÑÑÐ¾ Ð·Ð½Ð°ÑÐ¸Ñ, ÑÑÐ¾ Ð¸Ð´ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ
                ÑÐ¸ÑÑÐµÐ¼Ñ â Ð¾Ð½Ð¾ Ð·Ð°Ð½Ð¸Ð¼Ð°ÐµÑ Ð¼ÐµÐ½ÑÑÐµ Ð¼Ð¸Ð½ÑÑÑ.
              </p>
              <p style={{ marginTop: 10 }}>
                ÐÐ¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ Ð¼Ð¸Ð½ÑÑÑ Ð¸ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ. ÐÐ²ÐµÐ´ÑÐ½Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ Ð½Ðµ Ð¿Ð¾ÑÐµÑÑÑÑÑÑ.
                ÐÑÐ»Ð¸ Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿Ð¾Ð²ÑÐ¾ÑÑÐµÑÑÑ Ð´Ð¾Ð»ÑÑÐµ Ð¿ÑÑÐ¸ Ð¼Ð¸Ð½ÑÑ â ÑÐ¾Ð¾Ð±ÑÐ¸ÑÐµ ÑÐ°Ð·ÑÐ°Ð±Ð¾ÑÑÐ¸ÐºÐ°Ð¼.
              </p>
            </>
          ) : (
            <p>{error.message}</p>
          )}
          {error.details && showDetails && (
            <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(error.details, null, 2)}</pre>
          )}
          {!showDetails && (
            <p
              onClick={() => setShowDetails(true)}
              style={{ marginTop: 15, color: '#8E8E93', cursor: 'pointer', fontSize: 14 }}
            >
              ÐÐ¾Ð´ÑÐ¾Ð±Ð½Ð¾ÑÑÐ¸ Ð´Ð»Ñ ÑÐ°Ð·ÑÐ°Ð±Ð¾ÑÑÐ¸ÐºÐ°
            </p>
          )}
        </div>
        <div style={{
          gap: 20,
          display: 'flex',
          marginTop: 'auto'
        }}>
          <Button fill onClick={handleCopyCurl}>Ð¡ÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°ÑÑ cURL</Button>
          <Button fill onClick={handleCopyError}>Ð¡ÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°ÑÑ ÑÐµÐºÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¸</Button>
        </div>
      </div>
    </Modal>
  );
};

export default GlobalErrorModal;
